// Загрузка файла
export const download = (filename, text) => {
    let element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent("\uFEFF" + text));
        element.setAttribute('download', filename);
        element.style.display = 'none';
    
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
};

// Toast
let autoCloseToast;
export const toastbox = (target, time) => {
    const closeToastBox = () => {
        document.querySelectorAll('.toast-box').forEach(function (el) {
            el.classList.remove('show');
            clearTimeout(autoCloseToast);
        })
    };
    
    let a = document.getElementById(target);
    closeToastBox();
    setTimeout(() => {a.classList.add('show')}, 100);
    if (time) {
        time = time + 100;
        autoCloseToast = setTimeout(() => {closeToastBox()}, time);
    }
};

export const map = (x, in_min, in_max, out_min, out_max) => {
    return (x - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
};
